module.exports = __webpack_public_path__ + "8ec7049df73562fa830d410456973d65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_55.jpg
// module id = 1682
// module chunks = 5